export class FormUser {
    username?: string;
    email?: string;
    password?: string;
    confirmPassword?: string;
    firstName?: string;
    lastName?: string;
    constructor() {
        this.firstName = '';
        this.lastName = '';
    }
}
